import React from 'react';
import { Link } from 'react-router-dom';
import ReactCountryFlag from "react-country-flag";
import './ListView.scss';

const ListView = ({url, speed, counts, countryname, nodename, countryflagname}) => {
    return (
      <Link to={url} className="list-card">
          <div className="list-card-inner">
            <div className="list-left">
                <ReactCountryFlag svg countryCode={countryflagname}
                    style={{
                        width: '2em',
                        height: '2em',
                    }}
                />
                <div className="country-name">{nodename} {countryname}</div>
            </div>
            <div className="list-right">
                {speed && (<span>{speed}mbps</span>)}
                {counts && (<span>{counts}</span>)}
            </div>
          </div>
      </Link>  
    )
}

export default ListView